import * as React from 'react';

import { getAccessToken } from '../../Common';

import {
    Box,
    Typography,
    Checkbox,
    Button,
} from '@mui/material';

const DEFAULT_IMAGE_01 = '/image/TrafficVolume/image001.png'
const DEFAULT_IMAGE_02 = '/image/TrafficVolume/image002.png'

interface resultProps {
    props: {
        planAreaId: string | null;
        branch: string | null;
        locationTraffic5mcut: any;
    }
}

const Approval5mcutDetail: React.FC<resultProps> = ({ props }) => {

    const [image001, setImage001] = React.useState<string>(DEFAULT_IMAGE_01)
    const [image002, setImage002] = React.useState<string>(DEFAULT_IMAGE_02)

    const [approval5MMgr, setApproval5MMgr] = React.useState<boolean>(false)
    const [approvalResearchMgrStamp, setApprovalResearchMgrStamp] = React.useState<string>("")
    const [approvalResearchGmStamp, setApprovalResearchGmStamp] = React.useState<string>("")
    const [approvalResearchGmFlag, setApprovalResearchGmFlag] = React.useState<boolean>(false)
    const [approvalMgrStamp, setApprovalMgrStamp] = React.useState<string>("")
    const [approvalGmStamp, setApprovalGmStamp] = React.useState<string>("")


    const [checkList, setCheckList] = React.useState([
        { 'name': "0", 'key': 'check_planting', 'checked': false, label: '店舗入口ドア予定位置前に植栽等障害物がない' },
        { 'name': "1", 'key': 'check_visibility', 'checked': false, label: '5ｍ外算入範囲から新店頭看板・入口ドアが視認可能​' },
        { 'name': "2", 'key': 'check_stairs', 'checked': false, label: '店舗入口ドア予定位置まで階段等段差がない' },
        { 'name': "3", 'key': 'check_count', 'checked': false, label: '道路の反対側をカウントする場合、車交通量が少なく店舗への往来に支障がない事' },
    ])

    const setChecked = (target: number) => {
        return checkList[Number(target)]['checked']
    }

    React.useEffect(() => {
        const bucket_path = process.env.REACT_APP_GOOGLE_STORAGE
            + '/' + process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
            + '/' + props.planAreaId
            + '/' + props.branch
        const access_token = getAccessToken()
        if (props.locationTraffic5mcut) {
            if (props.locationTraffic5mcut.layout_img_path) {
                setImage001(bucket_path + props.locationTraffic5mcut.layout_img_path + access_token)
            } else {
                setImage001(DEFAULT_IMAGE_01)
            }
            if (props.locationTraffic5mcut.photo_img_path) {
                setImage002(bucket_path + props.locationTraffic5mcut.photo_img_path + access_token)
            } else {
                setImage002(DEFAULT_IMAGE_02)
            }

            // 5m外印影画像
            if (props.locationTraffic5mcut.approval_research_mgr_stamp) {
                setApprovalResearchMgrStamp(bucket_path + props.locationTraffic5mcut.approval_research_mgr_stamp + access_token)
            }
            if (props.locationTraffic5mcut.approval_research_gm_flag === "1" &&
                props.locationTraffic5mcut.approval_research_gm_stamp) {
                setApprovalResearchGmStamp(bucket_path + props.locationTraffic5mcut.approval_research_gm_stamp + access_token)
                setApprovalResearchGmFlag(true);
            }
            if (props.locationTraffic5mcut.approval_mgr_stamp) {
                setApprovalMgrStamp(bucket_path + props.locationTraffic5mcut.approval_mgr_stamp + access_token)
            }
            if (props.locationTraffic5mcut.approval_gm_stamp) {
                setApprovalGmStamp(bucket_path + props.locationTraffic5mcut.approval_gm_stamp + access_token)
            }
            // checkList
            handleCheckList(props.locationTraffic5mcut)
        }
    }, [props.locationTraffic5mcut])

    const handleCheckList = (data: any) => {
        const tmpCheckList = [
            { 'name': "0", 'key': 'check_planting', 'checked': false, label: '店舗入口ドア予定位置前に植栽等障害物がない' },
            { 'name': "1", 'key': 'check_visibility', 'checked': false, label: '5ｍ外算入範囲から新店頭看板・入口ドアが視認可能​' },
            { 'name': "2", 'key': 'check_stairs', 'checked': false, label: '店舗入口ドア予定位置まで階段等段差がない' },
            { 'name': "3", 'key': 'check_count', 'checked': false, label: '道路の反対側をカウントする場合、車交通量が少なく店舗への往来に支障がない事' },
        ]
        if (data.check_planting === "1") {
            tmpCheckList[0]['checked'] = true
        }
        if (data.check_visibility === "1") {
            tmpCheckList[1]['checked'] = true
        }
        if (data.check_stairs === "1") {
            tmpCheckList[2]['checked'] = true
        }
        if (data.check_count === "1") {
            tmpCheckList[3]['checked'] = true
        }

        setCheckList(tmpCheckList)
    }

    return (
        <Box sx={{ display: props.locationTraffic5mcut.cut_survey === "1" ? 'block' : 'none' }}>
            <Box><h3>5m外算入根拠</h3></Box>
            <Box>
                <Box sx={{ display: 'flex' }}>
                    <Box sx={{ width: '120px', border: '1px solid #000', textAlign: 'center' }}>リサーチ Mgr</Box>
                    <Box sx={{ width: '120px', border: '1px solid #000', textAlign: 'center', display: approvalResearchGmFlag ? "block":"none" }}>リサーチ GM</Box>
                    <Box sx={{ width: '120px', border: '1px solid #000', textAlign: 'center' }}>リクルート Mgr</Box>
                    <Box sx={{ width: '120px', border: '1px solid #000', textAlign: 'center' }}>リクルート GM</Box>
                </Box>
                <Box sx={{ display: 'flex' }}>
                    <Box sx={{ width: '120px', height: '92px', border: '1px solid #000', textAlign: 'center' }}><img src={approvalResearchMgrStamp}></img></Box>
                    <Box sx={{ width: '120px', height: '92px', border: '1px solid #000', textAlign: 'center', display: approvalResearchGmFlag ? "block":"none" }}><img src={approvalResearchGmStamp}></img></Box>
                    <Box sx={{ width: '120px', height: '92px', border: '1px solid #000', textAlign: 'center' }}><img src={approvalMgrStamp}></img></Box>
                    <Box sx={{ width: '120px', height: '92px', border: '1px solid #000', textAlign: 'center' }}><img src={approvalGmStamp}></img></Box>
                </Box>
            </Box>
            <Box sx={{ display: 'flex' }}>
                <Box sx={{ margin: '10px' }}>
                    <Typography>配置図または航空写真<br />（5m内外の計測範囲を記載）</Typography>
                    <Box sx={{ border: '1px solid black' }}>
                        <img src={image001} style={{ width: '560px', maxWidth: '560px' }} />
                    </Box>
                </Box>
                <Box sx={{ margin: '10px' }}>
                    <Typography>写真（障害物有無がわかる）<br />（5m内外の計測範囲を記載）</Typography>
                    <Box sx={{ border: '1px solid black' }}>
                        <img src={image002} style={{ width: '560px', maxWidth: '560px' }} />
                    </Box>
                </Box>
            </Box>
            <Box><Typography>5m外歩行者TR算入確認</Typography></Box>
            {checkList.map((row: any) => (
                <Typography key={row.key}>
                    <Checkbox
                        checked={setChecked(row['name'])}
                        name={row['name']}
                        disabled={true}
                    ></Checkbox>{row.label}</Typography>
            ))}
        </Box>
    )

}

export default Approval5mcutDetail;
